import { _ as __rest } from '../../../../tslib.es6-C8rd5pYo.mjs';
import { writeCookie, readCookie } from '@zapier/cookies';
import { emit } from '@zapier/events-toolkit-browser';

const setCookie = (id, value, maxAge, path = "/") => {
  try {
    writeCookie(id, value, {
      // Cookies are categorized as `essential` for backwards compatibility,
      // but devs should use `writeCookie` from `@zapier/cookies` with
      // the correct `category`.
      category: "essential",
      maxAge,
      path
    });
  } catch (e) {
    console.error("Unable to set cookie", {
      id
    });
  }
};
const getCookie = (id) => {
  try {
    return readCookie(id);
  } catch (e) {
    return void 0;
  }
};
const UserInteractionEvent = "web_analytics.tracking.user_interaction.UserInteractionEvent";
const emitUserInteractionEvent = async (_a) => {
  var eventDetails = __rest(_a, []);
  return await emit(Object.assign(Object.assign({}, eventDetails), { absolute_url: window.location.pathname, referrer: document.referrer, system_name: "design_system" }), UserInteractionEvent);
};

export { setCookie as default, emitUserInteractionEvent, getCookie, setCookie };
//# sourceMappingURL=utils.es.js.map
